import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  ChatParticipantDto,
  ChatParticipantReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import ChatParticipantInline, { ChatParticipantInlineProps } from "./ChatParticipantInline";

interface Props extends BaseEntityLinkInheritableProps {
  chatId: string | null | undefined;
  entity: ChatParticipantDto | ChatParticipantReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<ChatParticipantInlineProps>;
}
export default function ChatParticipantLink({
  chatId,
  entity,
  entityId,
  inlineProps,
  ...otherProps
}: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.ChatRead]}
      to={ROUTE_PATH.TENANT_REQUEST_VIEW(entity?.id || entityId || "")}
      content={
        <ChatParticipantInline
          chatId={chatId}
          entity={entity}
          entityId={entityId}
          {...inlineProps}
        />
      }
      {...otherProps}
    />
  );
}
